<template>
    <tr :class="[volunteerType == 'sponsor' ? 'green' : '']">
        <td>
            <a @click="openPopup">{{ name }}</a>
        </td>
        <td>{{ location }}</td>
        <td><span v-if="role == 'DRIVER'">Driver</span><span v-if="role == 'OTHER'">Walking</span><span v-if="withHelper"> + Helper</span></td>
    </tr>
    <div v-if="showPopup">
        <VolunteerModal @close-popup="closePopup" :userID="id" :fdID="this.fdID"></VolunteerModal>
    </div>
</template>

<script>
import VolunteerModal from './VolunteerModal.vue';

export default {
    components: {
        VolunteerModal
    },
    props: [
        'id',
        'fdID',
        'name',
        'location',
        'role',
        'canBeHelper',
        'withHelper',
        'team',
        'volunteerType'
    ],
    data() {
        return {
            showPopup: false
        }
    },
    methods: {
        openPopup() {
            this.showPopup = true;
        },
        closePopup() {
            this.showPopup = false
        }
    }
}
</script>